module.exports = __webpack_public_path__ + "static/media/anup_nair.aabf3823.jpg";